export default () => ({
  setTables: false,
  tables: []
})
